import axios from 'axios';

import { TGetCompany, TCompanyEntity } from '../../types/TCompany';

export default async function getCompany({
  accessToken,
  id,
  setTokenLikeExpired,
}: TGetCompany): Promise<TCompanyEntity | null> {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_COMPANIES_API_URL}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err: any) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  }
}
